// extracted by mini-css-extract-plugin
export default {"hintIcon":"wbx6aGDRaZt2eFB3GATi","hintText":"C6dvJeYNv54IRLR9nzsL","okButton":"Tb8qm2o3gbqspRD6nHBC"};